import * as React from 'react';

function PdfIcon(props) {
  return (
    <svg width="40" height="40" viewBox="0 0 31.669 42.226" {...props}>
      <path
        d="M15 21.121c-.412-1.32-.4-3.868-.165-3.868.694 0 .628 3.047.165 3.868zm-.14
          3.893a38.055 38.055 0 01-2.342 5.171 30.368 30.368 0 015.187-1.806 10.683 10.683
          0 01-2.844-3.365zM7.1 35.306c0 .066 1.089-.445 2.878-3.315-.551.519-2.399
          2.02-2.878 3.315zM20.453 13.2h11.216v27.046a1.975 1.975 0 01-1.979
          1.979H1.979A1.975 1.975 0 010 40.246V1.979A1.975 1.975 0
          011.979 0h16.495v11.216a1.985 1.985 0 001.979 1.984zm-.66 14.169a8.277 8.277
          0 01-3.522-4.437c.371-1.526.957-3.843.511-5.295a2.066 2.066 0 00-3.942-.561c-.412
          1.509-.033 3.637.668 6.35a77.443 77.443 0 01-3.364 7.074c-.008 0-.008.008-.016.008-2.235 1.146-6.07
          3.67-4.495 5.608a2.563 2.563 0 001.773.825c1.476 0 2.944-1.484 5.039-5.1a47.01 47.01 0 016.515-1.913
          12.5 12.5 0 005.278 1.608 2.135 2.135 0
          001.625-3.579c-1.146-1.122-4.478-.8-6.07-.594zm11.3-18.7L23.01.577A1.978 1.978
          0 0021.608 0h-.495v10.556h10.556v-.5a1.973
          1.973 0 00-.577-1.396zm-6.112 21.046c.338-.223-.206-.981-3.53-.742 3.06 1.302 3.53.742 3.53.742z"
        fill="#e53e3e"
      />
    </svg>
  );
}

export default PdfIcon;
